import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IFmlmSelectLocationActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/FmlmSelectLocationActionParams";
import { LocationState } from "../../../Orchestrator/Types/Types/FmlmSearch/FmlmSearchType";
import { distanceCalculate } from "../../LogicActions/FmlmSearch/FmlmDistanceService";

class FmlmSelectLocationAction extends BaseAction<void, IFmlmSelectLocationActionParams> {
  private async calculateDistance(
    [lng, lat]: [number, number],
    locationPermission: any
  ): Promise<number> {
    if (!(locationPermission.isGranted && locationPermission.position)) {
      return 0; // Return 0 if location permission is not granted
    }

    const startCoordinates: [number, number] = locationPermission?.position && [
      locationPermission.position.coords.longitude,
      locationPermission.position.coords.latitude,
    ];
    // let startCoordinates: [number, number] = [54.3773, 24.4539]; // Default coordinates for Abu Dhabi

    let calculateDistance = await distanceCalculate(startCoordinates, [[lng, lat]]);

    return calculateDistance?.[0];
  }

  override async run() {
    if (!this.params) {
      throw new Error("Location parameters are required");
    }

    const {
      name,
      place_formatted,
      coordinates,
      distanceFromStart,
      selectedExactLocation,
      id,
      locationPermission,
      locationType
    } = this.params;

    try {
      const isOrigin = selectedExactLocation === "origin";
      const distance =
        distanceFromStart ?? (await this.calculateDistance(coordinates, locationPermission));

      const locationData: LocationState = {
        id,
        name,
        place_formatted,
        coordinates,
        distanceFromStart: distance,
        locationType
      };

      const locationAtom = isOrigin ? "selectedLocationAtom" : "selectedLocationDestinationAtom";
      updateRecoilState(locationAtom, locationData);
    } catch (error) {
      console.error("Error selecting location:", error);
      throw error;
    }
  }
}

export const selectLocationAction = new FmlmSelectLocationAction();
